module.exports = __webpack_public_path__ + "img/icepay-logo.39950744.png";